export const loginSVGs = {
  bottomCircle: ({ width = 283, height = 337, className, ...rest }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 283 337"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M240.806 481.613C373.8 481.613 481.613 373.8 481.613 240.806C481.613 107.813 373.8 0 240.806 0C107.813 0 0 107.813 0 240.806C0 373.8 107.813 481.613 240.806 481.613Z"
        fill="url(#paint0_linear_11_21)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11_21"
          x1="0.00096"
          y1="240.797"
          x2="481.623"
          y2="240.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#88A8FE" />
          <stop offset="1" stopColor="#311996" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),

  topCircle: ({ width = 111, height = 101, className, ...rest }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 111 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M88.8576 100.715C137.932 100.715 177.715 60.9323 177.715 11.8576C177.715 -37.2171 137.932 -77 88.8576 -77C39.7829 -77 0 -37.2171 0 11.8576C0 60.9323 39.7829 100.715 88.8576 100.715Z"
        fill="url(#paint0_linear_11_27)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11_27"
          x1="88.8577"
          y1="100.712"
          x2="88.8577"
          y2="-76.9994"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40A4FF" />
          <stop offset="0.634615" stopColor="#2958FE" />
        </linearGradient>
      </defs>
    </svg>
  ),

  lineIcons: ({ width = 208, height = 57, className, ...rest }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 208 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path d="M1 1L56.3152 56.3344" stroke="#F8F0E4" strokeMiterlimit="10" />
      <path d="M56.3152 1L1 56.3344" stroke="#F8F0E4" strokeMiterlimit="10" />
      <path
        d="M76.2065 1L131.541 56.3344"
        stroke="#F8F0E4"
        strokeMiterlimit="10"
      />
      <path
        d="M131.541 1L76.2065 56.3344"
        stroke="#F8F0E4"
        strokeMiterlimit="10"
      />
      <path
        d="M151.413 1L206.747 56.3344"
        stroke="#F8F0E4"
        strokeMiterlimit="10"
      />
      <path
        d="M206.747 1L151.413 56.3344"
        stroke="#F8F0E4"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  appIcon: ({ width = 120, height = 30, className, ...rest }) => (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 132 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.072 70.448C16.128 70.448 13.4827 69.936 11.136 68.912C8.832 67.8453 7.01867 66.3947 5.696 64.56C4.37333 62.6827 3.69067 60.528 3.648 58.096H9.856C10.0693 60.1867 10.9227 61.9573 12.416 63.408C13.952 64.816 16.1707 65.52 19.072 65.52C21.8453 65.52 24.0213 64.8373 25.6 63.472C27.2213 62.064 28.032 60.272 28.032 58.096C28.032 56.3893 27.5627 55.0027 26.624 53.936C25.6853 52.8693 24.512 52.0587 23.104 51.504C21.696 50.9493 19.7973 50.352 17.408 49.712C14.464 48.944 12.096 48.176 10.304 47.408C8.55467 46.64 7.04 45.4453 5.76 43.824C4.52267 42.16 3.904 39.9413 3.904 37.168C3.904 34.736 4.52267 32.5813 5.76 30.704C6.99733 28.8267 8.72533 27.376 10.944 26.352C13.2053 25.328 15.7867 24.816 18.688 24.816C22.8693 24.816 26.2827 25.8613 28.928 27.952C31.616 30.0427 33.1307 32.816 33.472 36.272H27.072C26.8587 34.5653 25.9627 33.072 24.384 31.792C22.8053 30.4693 20.7147 29.808 18.112 29.808C15.68 29.808 13.696 30.448 12.16 31.728C10.624 32.9653 9.856 34.7147 9.856 36.976C9.856 38.5973 10.304 39.92 11.2 40.944C12.1387 41.968 13.2693 42.7573 14.592 43.312C15.9573 43.824 17.856 44.4213 20.288 45.104C23.232 45.9147 25.6 46.7253 27.392 47.536C29.184 48.304 30.72 49.52 32 51.184C33.28 52.8053 33.92 55.024 33.92 57.84C33.92 60.016 33.344 62.064 32.192 63.984C31.04 65.904 29.3333 67.4613 27.072 68.656C24.8107 69.8507 22.144 70.448 19.072 70.448ZM115.565 38.448C115.565 42.16 114.285 45.2533 111.725 47.728C109.207 50.16 105.346 51.376 100.141 51.376H91.5645V70H85.7405V25.392H100.141C105.175 25.392 108.994 26.608 111.597 29.04C114.242 31.472 115.565 34.608 115.565 38.448ZM100.141 46.576C103.383 46.576 105.773 45.872 107.309 44.464C108.845 43.056 109.613 41.0507 109.613 38.448C109.613 32.944 106.455 30.192 100.141 30.192H91.5645V46.576H100.141Z"
        fill="white"
      />
      <path
        d="M59.5014 28.2775C58.2612 28.2775 57.2592 29.4567 57.2592 30.9163C57.2592 32.3759 58.2612 33.5551 59.5014 33.5551C60.7415 33.5551 61.7435 32.3759 61.7435 30.9163C61.7435 29.4567 60.7415 28.2775 59.5014 28.2775ZM52.775 30.9163C52.775 26.5458 55.7879 23 59.5014 23C63.2148 23 66.2277 26.5458 66.2277 30.9163C66.2277 34.3632 64.3569 37.2988 61.7435 38.3791V59.6459C66.1506 58.4667 69.4648 48.4404 69.5839 42.932L68.4558 44.0947C67.7552 44.8121 66.6972 44.7297 66.0806 43.9051C65.464 43.0804 65.5411 41.8353 66.2418 41.1096L70.726 36.4918C71.3566 35.8403 72.3095 35.8403 72.9401 36.4918L77.4243 41.1096C78.1249 41.827 78.195 43.0804 77.5854 43.9051C76.9758 44.7297 75.9108 44.8121 75.2102 44.0947L74.0751 42.932C73.928 52.2584 67.4608 70 59.5014 70C51.5419 70 45.0749 52.2584 44.9277 42.932L43.7927 44.103C43.092 44.8204 42.034 44.7379 41.4174 43.9133C40.8008 43.0887 40.8779 41.8435 41.5786 41.1178L46.0628 36.5C46.6934 35.8486 47.6463 35.8486 48.2769 36.5L52.7611 41.1178C53.4617 41.8353 53.5318 43.0887 52.9222 43.9133C52.3127 44.7379 51.2477 44.8204 50.547 44.103L49.4189 42.9403C49.5451 48.4487 52.8591 58.475 57.2592 59.6542V38.3873C54.6458 37.2988 52.775 34.3715 52.775 30.9246V30.9163Z"
        fill="white"
      />
    </svg>
  ),
};
